/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Declares which auxiliary steps a provider requires to support subscriptions, beyond the per-object subscribe call itself.
 * @export
 * @interface SubscribeRequirements
 */
export interface SubscribeRequirements {
    /**
     * Whether the provider requires a one-time registration step that is shared across all subscribed objects. The subscribe method is object-scoped, so if a separate API call is needed beyond per-object configuration (e.g., registering a single webhook/endpoint that all object subscriptions hang off of), registration is required.
     * @type {boolean}
     * @memberof SubscribeRequirements
     */
    registration?: boolean;
    /**
     * Whether the subscription requires periodic maintenance. Some providers expire subscriptions/watches after a fixed TTL, so the subscription must be renewed on a schedule to remain active.
     * @type {boolean}
     * @memberof SubscribeRequirements
     */
    maintenance?: boolean;
    /**
     * Whether subscribing requires a third-party setup step that the connector instance itself cannot perform. Examples: Salesforce requires AWS EventBridge configuration; Gmail requires a Google Pub/Sub topic to be configured. Any configuration that must happen outside the connector falls into post-process.
     * @type {boolean}
     * @memberof SubscribeRequirements
     */
    postProcess?: boolean;
    /**
     * Whether the provider supports programmatic subscription via API. If false, provider may still support webhooks via manual configuration in UI. 
     * @type {boolean}
     * @memberof SubscribeRequirements
     */
    subscribeByAPI?: boolean;
}

/**
 * Check if a given object implements the SubscribeRequirements interface.
 */
export function instanceOfSubscribeRequirements(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SubscribeRequirementsFromJSON(json: any): SubscribeRequirements {
    return SubscribeRequirementsFromJSONTyped(json, false);
}

export function SubscribeRequirementsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscribeRequirements {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'registration': !exists(json, 'registration') ? undefined : json['registration'],
        'maintenance': !exists(json, 'maintenance') ? undefined : json['maintenance'],
        'postProcess': !exists(json, 'postProcess') ? undefined : json['postProcess'],
        'subscribeByAPI': !exists(json, 'subscribeByAPI') ? undefined : json['subscribeByAPI'],
    };
}

export function SubscribeRequirementsToJSON(value?: SubscribeRequirements | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'registration': value.registration,
        'maintenance': value.maintenance,
        'postProcess': value.postProcess,
        'subscribeByAPI': value.subscribeByAPI,
    };
}

